(function () {
  var ROOT_SEL = '[data-contact-drawer-reviews]';
  var ENGINE_SEL = '[data-reviews-elfsight-engine]';
  var RATING_SEL = '[data-reviews-rating]';
  var COUNT_SEL = '[data-reviews-count]';

  function $(root, sel) {
    return root ? root.querySelector(sel) : null;
  }

  function getWidgetRoot(engine) {
    if (!engine) return null;
    return engine.querySelector('[class*="elfsight-app-"]') || engine.firstElementChild;
  }

  function parseCount(text) {
    if (!text) return '';
    var digits = text.replace(/[^\d]/g, '');
    if (!digits) return text.trim();
    var n = parseInt(digits, 10);
    if (n >= 90) return '90+';
    return String(n);
  }

  function syncBadgeText(root) {
    var engine = $(root, ENGINE_SEL);
    var widgetRoot = getWidgetRoot(engine);
    if (!widgetRoot) return false;

    var ratingEl =
      widgetRoot.querySelector('[class*="RatingValue"]') ||
      widgetRoot.querySelector('[class*="rating-value"]');
    var countEl =
      widgetRoot.querySelector('[class*="ReviewsCount"]') ||
      widgetRoot.querySelector('[class*="reviews-count"]') ||
      widgetRoot.querySelector('[class*="Count"]');

    var ratingNode = $(root, RATING_SEL);
    var countNode = $(root, COUNT_SEL);

    if (ratingEl && ratingNode) {
      var ratingText = (ratingEl.textContent || '').trim();
      if (ratingText) ratingNode.textContent = ratingText;
    }

    if (countEl && countNode) {
      var countText = (countEl.textContent || '').trim();
      if (countText) countNode.textContent = parseCount(countText);
    }

    return true;
  }

  function watchEngine(root) {
    var engine = $(root, ENGINE_SEL);
    if (!engine) return;

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      syncBadgeText(root);
      if (tries >= 40) window.clearInterval(timer);
    }, 500);

    if (typeof MutationObserver === 'function') {
      var observer = new MutationObserver(function () {
        syncBadgeText(root);
      });
      observer.observe(engine, { childList: true, subtree: true, characterData: true });
    }
  }

  function initRoot(root) {
    root.addEventListener('click', function (e) {
      e.stopPropagation();
    });
    root.addEventListener('mousedown', function (e) {
      e.stopPropagation();
    });
    watchEngine(root);
  }

  function init() {
    document.querySelectorAll(ROOT_SEL).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
